import { gql } from "@apollo/client";

export const QUERY_AVAILABLE_RADIO_EVENTS = gql`
  query getAvailableRadioEvents {
    getAvailableRadioEvents
  }
`;

export const QUERY_RADIOS_FOR_EVENT = gql`
  query getRadiosForEvent($event: String!) {
    getRadiosForEvent(event: $event) {
      sessions {
        session
        raw
        summary
      }
    }
  }
`;

export const QUERY_PRESIGNED_URL_FOR_RADIO = gql`
  query getPresignedURLForRadio(
    $event: String!
    $session: String!
    $type: String!
    $driver: String!
  ) {
    getPresignedURLForRadio(
      event: $event
      session: $session
      type: $type
      driver: $driver
    )
  }
`;
